<template>
    <div class="team">
        <content-header>
            <content-header-title slot="header-left">
                <span>{{$t('planHome.JNCP')}}</span>
            </content-header-title>
            <el-button type="primary" size="small" @click="goCreateExercise" v-if="__userData.userType < 2 " slot="header-right"> {{$t('planHome.XJLX')}}</el-button>
        </content-header>
        <div class="content">
            <team-seach
                @changeLayout="changeLayout"  
                :currentLayout="currentLayout" 
                ref="planSeach"></team-seach>
            <list-box 
                :currentLayout="currentLayout" 
                ref="listBox"></list-box>
        </div>
    </div>
</template>

<script>
import teamSeach from '@/views/planHome/plan-seach'
import listBox from '@/views/planHome/list-box'
import main from '@/mins/main'
import mins from '@/views/planHome/mins'
import { getLStore, setLStore } from '@/utils/common'
export default {
    name: 'planHome',
    data(){
        return{
            currentLayout: getLStore('currentLayout') || 'block'
        }
    },
    components:{
        teamSeach,
        listBox
    },
    methods:{
        changeLayout(val){
            this.currentLayout = val;
            setLStore('currentLayout', val);
        }
    },
    mixins: [main,mins]
}
</script>
<style scoped>
.team{
    height: 100%;
}
.content{
    padding: 0 24px;
}
</style>